import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => (
  <div>
    <h1>
      Page does not exist!
    </h1>
    <Link to="/">
      Go back to home page
    </Link>

  </div>
);

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/components/NotFoundPage.js